/**
 * 通过地图获取位置信息（百度地图版）
 */
import React, { useEffect, useState, useRef } from 'react';
import { Modal, message, Input } from 'antd';
import { importMap } from '@/utils/map'; // 引入百度地图

interface MapLocationModalProps {
  initLnglat?: any; // 地图中心的初始经纬度信息
  closeModal: () => void; // 关闭弹窗的方法
  confirmLocationFunc: (lnglat: any, address: string) => void; // 确认位置的方法
}
const { Search } = Input;
const MapLocationModal = (props: MapLocationModalProps) => {
  const { closeModal, confirmLocationFunc, initLnglat } = props;
  const mapRef = useRef<any>(null); // 地图实例
  const geocoderRef = useRef<any>(); // 地理编码工具实例
  const [lnglat, setLnglat] = useState<any>(null); // 选择的位置
  const [selectAddress, setSelectAddress] = useState<string>(''); // 选择的地址信息

  useEffect(() => {
    importMap(initMap);
    return () => {
      mapRef.current = null;
    };
  }, [])

  // 初始化地图
  const initMap = () => {
    try {
      // 能获取当前位置时初始地图位置
      let center = new window.BMap.Point(116.397428, 39.90923);
      if (initLnglat) {
        center = new window.BMap.Point(initLnglat.lng, initLnglat.lat);
      }
      // 创建地图实例
      mapRef.current = new window.BMap.Map('mapLocationModal');
      mapRef.current.centerAndZoom(center, 14);
      mapRef.current.enableScrollWheelZoom();

      // 添加比例尺控件（对应 AMap.Scale）
      mapRef.current.addControl(new window.BMap.ScaleControl({
        anchor: window.BMAP_ANCHOR_BOTTOM_LEFT,
      }));
      // 添加缩放控件（对应 AMap.ToolBar）
      mapRef.current.addControl(new window.BMap.NavigationControl({
        anchor: window.BMAP_ANCHOR_TOP_LEFT,
      }));
      // 添加地图类型控件（对应 AMap.MapType）
      mapRef.current.addControl(new window.BMap.MapTypeControl({
        mapTypes: [window.BMAP_NORMAL_MAP, window.BMAP_HYBRID_MAP],
      }));

      // 创建地理编码插件实例
      geocoderRef.current = new window.BMap.Geocoder();

      // 为地图添加点击事件监听
      mapRef.current.addEventListener('click', mapClick);
    } catch (error) {
      message.error('地图初始化失败');
    }
  }

  // 添加marker
  const addMarker = (lnglat: any, address: string) => {
    const point = new window.BMap.Point(lnglat.lng, lnglat.lat);
    const marker = new window.BMap.Marker(point);
    const label = new window.BMap.Label(address, {
      offset: new window.BMap.Size(20, -10),
    });
    marker.setLabel(label);
    mapRef.current.clearOverlays();
    mapRef.current.addOverlay(marker);
    setLnglat(lnglat);
    setSelectAddress(address);
  }

  // 输入地址进行地理位置查询
  const onLocation = (value: string) => {
    geocoderRef.current.getPoint(value, function (point: any) {
      if (point) {
        mapRef.current.setCenter(point);
        addMarker(point, value);
      } else {
        message.error('根据输入地址查询地理位置失败，可完善地址信息重新查询');
      }
    });
  }

  // 地图点击
  const mapClick = (e: any) => {
    const point = e.point;
    const geocoder = new window.BMap.Geocoder();
    geocoder.getLocation(point, (result: any) => {
      if (result) {
        const addressComponents = result.addressComponents;
        const city = addressComponents.city || addressComponents.province;
        const address = city + addressComponents.district;
        addMarker(point, address);
      } else {
        message.error('选择的位置查询地址信息失败');
        setLnglat(null);
        setSelectAddress('');
      }
    });
  }

  // 点击确定
  const onOk = () => {
    confirmLocationFunc(lnglat, selectAddress);
    closeModal();
  }

  return (
    <Modal
      title='安装位置'
      visible
      onCancel={closeModal}
      centered
      onOk={onOk}
      okButtonProps={{ disabled: !lnglat || !selectAddress }}
    >
      <div style={{ marginBottom: '8px', fontWeight: 'bold' }}>可点击地图确定具体地址</div>
      <Search
        placeholder='可输入地址进行地理位置查询'
        onSearch={onLocation}
        enterButton
        style={{ marginBottom: '8px' }}
      />
      <div id="mapLocationModal" style={{ height: '400px' }} />
    </Modal>
  )
}

export default MapLocationModal;